import { register, format } from 'timeago.js';
import locale from 'timeago.js/lib/lang/id_ID.js';

export default class TimeagoAdapter {
  static indonesian(time){
    register('id_ID', locale);
    const isoString = new Date(time).toISOString()
    return format(isoString, 'id_ID');
  }
}